export default [
  'id',
  'email',
  'admin',
];
